/* eslint-disable import/first, import/newline-after-import */

import 'components/resources/show/resource-show-sidebar/resource-show-sidebar';
import 'components/resources/show/resource-show-native-ad/resource-show-native-ad';
import 'components/resources/show/resource-show-sidebar-pricing/resource-show-sidebar-pricing';
import 'components/util/ez-radio-button-toggle/ez-radio-button-toggle';
import(/* webpackChunkName: 'resource-info-modal', webpackPrefetch: true */ 'components/resources/show/resource-info-modal/resource-info-modal');
import(/* webpackChunkName: 'share-modal', webpackPrefetch: true */ 'components/util/social-sharing/share-modal/share-modal');

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import ResourceFavoriteController from 'components/resources/show/resource-show-details/resource-favorite-controller';
EezyStimulusApplication.register('resource-favorite', ResourceFavoriteController);

import EzRadioButtonToggleController from 'components/util/ez-radio-button-toggle/ez-radio-button-toggle-controller';
EezyStimulusApplication.register('ez-radio-button-toggle', EzRadioButtonToggleController);

import SocialButtonsController from 'components/util/social-sharing/social-buttons/social-buttons-controller';
EezyStimulusApplication.register('social-buttons', SocialButtonsController);

import NativeAdController from 'components/resources/show/resource-show-native-ad/native-ad-controller';
EezyStimulusApplication.register('native-ad', NativeAdController);
